module.exports = __webpack_public_path__ + "./assets/img_kaostation_grey@2x__cea32984d843efb4ee3727a24b1f0277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kaostation_grey@2x.jpg
// module id = 626
// module chunks = 12